<template>
  <section>
    <div
      id="alertunlinkedpages"
      ref="alertunlinkedpages"
      class="modal fade"
      tabindex="-1"
      :style="!isShow ? 'display: none;' : 'display: block;'"
      :class="isShow ? 'd-flex align-items-center justify-content-center': ''"
      aria-hidden="true"
      aria-labelledby="alertunlinkedpages"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div
        class="modal-dialog d-flex align-items-center justify-content-center"
        style="height: 100vh; max-width: 100vw; margin: 0;"
      >
        <div 
          class="modal-content"
          style="width: 37rem;"
        >
          <div class="d-flex flex-column align-items-center justify-content-center p-0">
            <img
              :src="
                $storeIndex.getImageSvgAssets(
                  'circle-exclamation-alert'
                )
              "
              class="img-fluid"
              style="margin: 20px;"
              alt=""
              width="80"
              height="80"
            >
            <div
              class="list-news flex-column"
            >
              <div 
                class="d-flex flex-column align-items-center justify-content-center" 
              >
                <span class="title-alert-disconnect">
                  {{ $t("_Advertise.Unlink Page From Dataset!") }}
                </span>

                <div
                  class="box-contain-unlink-page-warning"
                  style="margin-top: 12px;"
                >
                  <div class="contain-blue">
                    <i
                      class="fa-solid fa-circle-info"
                      style="color: #fff; width: 20px; height: 20px; font-size: 20px;"
                    />
                  </div>
                  <div class="contain-lighter-blue">
                    <span>
                      {{ $t("Found") }} {{ $store.state.itemsPageUnlink.length }} {{ $t("channels where page were unlink from the dataset on Facebook.") }} {{ $t(`Click "Go To Setting" to edit your facebook event method`) }}
                    </span>
                  </div>
                </div>

                <div class="d-flex flex-row align-items-center justify-content-center mt-3">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-normal-font mr-3"
                    data-dismiss="modal"
                    style="height: 2.25rem !important;"
                    @click="closeModal()"
                  >
                    <i class="fa-solid fa-circle-check mr-1" />{{ $t("_Advertise.Got It") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-normal-font"
                    style="height: 2.25rem !important;"
                    data-dismiss="modal"
                    @click="gotoSetting()"
                  >
                    <i class="fa-solid fa-circle-arrow-right mr-1" />{{ $t("_Advertise.Go To Setting") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { USER } from '@/vuex-store/types'

export default {
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    ...mapGetters({
      user: USER
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.showedPageDisconnected && !this.$store.state.showedPageUnlinked && this.$store.state.itemsPageUnlink.length) {
        this.isShow = true;
      }
    })
  },
  watch: {
    "$store.state.itemsPageUnlink"() {
      if (this.$store.state.showedPageDisconnected && !this.$store.state.showedPageUnlinked && this.$store.state.itemsPageUnlink.length) {
        if ($('#alertunlinkedpages')) $('#alertunlinkedpages').modal('show');
        if ($(this.$refs.alertunlinkedpages)) $(this.$refs.alertunlinkedpages).modal('show');
        this.isShow = true;
      }
    },
    "$store.state.showedPageDisconnected"() {
      // console.log("showedPageDisconnected: ", this.$store.state.showedPageDisconnected)
      if (this.$store.state.showedPageDisconnected && !this.$store.state.showedPageUnlinked && this.$store.state.itemsPageUnlink.length) {
        if ($('#alertunlinkedpages')) $('#alertunlinkedpages').modal('show');
        if ($(this.$refs.alertunlinkedpages)) $(this.$refs.alertunlinkedpages).modal('show');
        this.isShow = true;
      }
    },
  },
  methods: {
    closeModal() {
      this.$store.state.showedPageUnlinked = true;
      if ($('#alertunlinkedpages')) $('#alertunlinkedpages').modal('hide');
      if ($(this.$refs.alertunlinkedpages)) $(this.$refs.alertunlinkedpages).modal('hide');
      this.isShow = false;
    },
    gotoSetting() {
      let self = this;
      self.closeModal();
      self.$router.push("/settings/facebook-event-method").catch(() => {});
    },
  }
}
</script>

<style scoped>
.modal-content {
  padding: 20px !important;
}

.title-alert-disconnect {
  font-size: 17px;
  font-weight: 500;
  line-height: 20px;
  color: #515151;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalUnlinkPages.vue